import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import translate from '@i18n'

import { getTimePeriod } from './utils'

const StyledWelcomeMessage = styled.div`
  ${({
    theme: {
      typography: {
        bodycopy: {
          medium2: { bundledCSS: medium2BodyCopy },
        },
      },
    },
  }) => css`
    ${medium2BodyCopy}
    margin-bottom: 48px;
  `}
`

const Greeting = styled.div`
  ${({
    theme: {
      typography: {
        headings: {
          large: { bundledCSS: largeHeading },
        },
      },
    },
  }) => css`
    ${largeHeading}
  `}
`

const getTimeBasedGreeting = (): string => {
  const timePeriod = getTimePeriod()

  if (timePeriod === 'morning') {
    return translate('aiSearch.welcomeMessage.greeting.morning')
  } else if (timePeriod === 'afternoon') {
    return translate('aiSearch.welcomeMessage.greeting.afternoon')
  } else {
    return translate('aiSearch.welcomeMessage.greeting.evening')
  }
}

const WelcomeMessage: FunctionComponent = () => {
  return (
    <StyledWelcomeMessage>
      <Greeting>{getTimeBasedGreeting()}</Greeting>
      {translate('aiSearch.welcomeMessage.text')}
    </StyledWelcomeMessage>
  )
}

export default WelcomeMessage
